import React from "react";
import { Grid } from '@nextui-org/react';
import DashboardBalance from "./DashboardBalance";
import DashboardModuleFuel from './DashboardModuleFuel';
import DashboardModuleBurn from './DashboardModuleBurn';
import DashboardModuleProfile from './DashboardModuleProfile';
import DashboardPayItForward from "./DashboardPayItForward";
import DashboardTokenInfo from "./DashboardTokenInfo";
import DashboardModuleEcosystemSummary from "./DashboardModuleEcosystemSummary";



const Dashboard = ({ data, getData, account, rocketFiPrice, smartCodeData }) => {

  //console.log("Dashboard data:", data);

  return (
    <div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(150px, 100%), 1fr))',
        gap: '10px',
        marginTop: '10px',
        marginBottom: '10px',
      }}>

        <DashboardBalance data={data} account={account} rocketFiPrice={rocketFiPrice} smartCodeData={smartCodeData} />
        <DashboardModuleProfile data={data} getData={getData} />
        <DashboardTokenInfo data={data} rocketFiPrice={rocketFiPrice} />
        <DashboardPayItForward data={data} getData={getData} />


      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
        gap: '10px',
        marginTop: '10px',
        marginBottom: '10px',
      }}>

        <DashboardModuleEcosystemSummary data={data} getData={getData} rocketFiPrice={rocketFiPrice} />

        <DashboardModuleFuel data={data} getData={getData} />
      </div>

      {/* <DashboardModuleBurn data={data} getData={getData}  /> */}

    </div>
  );
};

export default Dashboard;


//material ui
// import React from "react";
// import Grid from '@mui/material/Grid';
// import DashboardBalance from "./DashboardBalance";
// import DashboardModuleFuel from './DashboardModuleFuel';
// import DashboardModuleBurn from './DashboardModuleBurn';
// import DashboardModuleProfile from './DashboardModuleProfile';
// import DashboardPayItForward from "./DashboardPayItForward";
// import DashboardTokenInfo from "./DashboardTokenInfo";
// import DashboardModuleEcosystemSummary from "./DashboardModuleEcosystemSummary";

// const Dashboard = ({ data, getData, account, rocketFiPrice, burnEvents, smartCodeData }) => {
//   return (
//     <div style={{ margin: '10px' }}>

//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <DashboardBalance data={data} account={account} rocketFiPrice={rocketFiPrice} smartCodeData={smartCodeData} />
//         </Grid>
//         <Grid item xs={12} sm={6} md={4}>
//           <DashboardModuleProfile data={data} getData={getData} />
//         </Grid>
//         <Grid item xs={12} sm={6} md={4}>
//           <DashboardTokenInfo data={data} rocketFiPrice={rocketFiPrice} />
//         </Grid>
//         <Grid item xs={12} sm={6} md={4}>
//           <DashboardPayItForward data={data} getData={getData} />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <DashboardModuleEcosystemSummary data={data} getData={getData} rocketFiPrice={rocketFiPrice} />
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <DashboardModuleFuel data={data} getData={getData} />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <DashboardModuleBurn data={data} getData={getData} burnEvents={burnEvents} />
//         </Grid>
//       </Grid>

//     </div>
//   );
// };

// export default Dashboard;